import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  productsPageView: 'grid' | 'table';
  productsPageFilter: 'ALL' | 'MINE';
  templatesPageView: 'grid' | 'table';
  templatesPageFilter: 'ALL' | 'MINE';
  productGroupsPageView: 'grid' | 'table';
  productGroupsPageFilter: 'ALL' | 'MINE';
  lastSavedProducts: {
    productId: string;
    lastUpdate: Date;
    lastUsed: Date;
  }[];
}

interface UIActions {
  setProductsPageView: (view: 'grid' | 'table') => void;
  setProductsPageFilter: (filter: 'ALL' | 'MINE') => void;
  setTemplatesPageView: (view: 'grid' | 'table') => void;
  setTemplatesPageFilter: (filter: 'ALL' | 'MINE') => void;
  setProductGroupsPageView: (view: 'grid' | 'table') => void;
  setProductGroupsPageFilter: (filter: 'ALL' | 'MINE') => void;
  setLastSavedProduct: (id: string, lastUpdate: Date) => void;
}

const initialState: UIState = {
  productsPageView: 'grid',
  productsPageFilter: 'ALL',
  templatesPageView: 'grid',
  templatesPageFilter: 'ALL',
  productGroupsPageView: 'grid',
  productGroupsPageFilter: 'ALL',
  lastSavedProducts: [],
};

export const useUiStore = create<UIState & UIActions>()(
  persist(
    (set) => ({
      ...initialState,
      setLastSavedProduct: (id, lastUpdate) =>
        set((state) => {
          // make sure we don't store more than 100 products
          // if we have more than 100 products, we only keep the last 10
          if (state.lastSavedProducts.length > 99) {
            state.lastSavedProducts = state.lastSavedProducts.slice(-10);
          }
          const now = new Date();
          // find the product and update it, else add it
          const product = state.lastSavedProducts.find((product) => product.productId === id);
          if (product) {
            product.lastUpdate = lastUpdate;
            product.lastUsed = now;
          } else {
            state.lastSavedProducts.push({
              productId: id,
              lastUpdate,
              lastUsed: now,
            });
          }

          return { lastSavedProducts: state.lastSavedProducts };
        }),
      setProductsPageView: (view) => set((state) => ({ ...state, productsPageView: view })),
      setProductsPageFilter: (filter) => set((state) => ({ ...state, productsPageFilter: filter })),
      setTemplatesPageView: (view) => set((state) => ({ ...state, templatesPageView: view })),
      setTemplatesPageFilter: (filter) => set((state) => ({ ...state, templatesPageFilter: filter })),
      setProductGroupsPageView: (view) => set((state) => ({ ...state, productGroupsPageView: view })),
      setProductGroupsPageFilter: (filter) => set((state) => ({ ...state, productGroupsPageFilter: filter })),
    }),

    {
      name: 'process-manager-ui',
    },
  ),
);
